import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CargomaticDropzone, DROPZONE_VARIANTS } from 'components/v2/Dropzone';
import classnames from 'classnames';
import ErrorAlert from 'components/ui/ErrorAlert';
import DocumentField from './DocumentField';
import { ACCEPTED_FILE_TYPES } from 'config/accepted-file-types';
import { withTranslation } from 'react-i18next';
import { getFilesWithContentType } from 'utils/files/files';

const maxSize = 2000000;

class Documents extends Component {
  static propTypes = {
    uploadPending: PropTypes.bool,
    documents: PropTypes.array,
    onCustomValueChange: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
  };

  static defaultProps = {
    uploadPending: false,
    documents: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      rejectedFiles: [],
    };
  }

  handleAcceptDrop = (files) => {
    const filesWithContentType = getFilesWithContentType(files);
    this.props.onDrop(filesWithContentType);
  };
  handleRejectDrop = (files) => {
    this.setState(
      {
        rejectedFiles: files.map((f) => f.name),
      },
      () => {
        setTimeout(() => {
          this.setState({ rejectedFiles: [] });
        }, 4000);
      },
    );
  };
  handleRemove = (i) => () => this.props.onRemove(i);
  handleTypeChange = (i) => (type) => this.props.onTypeChange(i, type);
  handleCustomValueChange = (i) => (value) =>
    this.props.onCustomValueChange(i, value);

  renderErrors() {
    if (!this.state.rejectedFiles || this.state.rejectedFiles.length === 0) {
      return null;
    }
    const { t } = this.props;
    return (
      <ErrorAlert title={t('MAX_FILE_SIZE_EXCEED')}>
        <ul>
          {this.state.rejectedFiles.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </ErrorAlert>
    );
  }

  renderDropzone() {
    const { t } = this.props;
    return (
      <fieldset className="">
        <div className="block mb-4">
          <CargomaticDropzone
            variant={DROPZONE_VARIANTS.BORDERED}
            className="flex justify-center items-center h-full"
            accept={ACCEPTED_FILE_TYPES}
            onDropAccepted={this.handleAcceptDrop}
            onDropRejected={this.handleRejectDrop}
            maxSize={maxSize}
          >
            {this.props.uploadPending && (
              <div className="flex items-center">
                <i className="fa fa-spinner fa-spin" />
                <span>{t('UPLOADING')}...</span>
              </div>
            )}
            {!this.props.uploadPending && (
              <p className="block text-grey-darker">
                {t('DROP_DOCUMENT_TO_ADD')}
              </p>
            )}
          </CargomaticDropzone>
        </div>
        {this.renderErrors()}
      </fieldset>
    );
  }
  renderDocuments() {
    if (!this.props.documents || this.props.documents.length === 0) {
      return null;
    }
    const { t } = this.props;
    return (
      <div className="documents w-full mb-4 md:mb-0 p-4 bg-grey-lightest">
        <label className="mb-2 block form-label">
          {t('ATTACHED_DOCUMENTS')}
        </label>
        {this.props.documents.map((doc, i) => (
          <DocumentField
            key={i}
            doc={doc}
            onRemove={this.handleRemove(i)}
            onTypeChange={this.handleTypeChange(i)}
            onCustomValueChange={this.handleCustomValueChange(i)}
          />
        ))}
      </div>
    );
  }
  render() {
    const { t } = this.props;
    return (
      <div className="documents-form">
        <h4 className="text-grey-dark mb-4">{t('ATTACH_DOCUMENTS')}</h4>
        {this.renderDropzone()}
        {this.renderDocuments()}
      </div>
    );
  }
}

export default withTranslation()(Documents);
